import React, {PropsWithChildren} from 'react';
import {Header} from "./Header";
import {ClosingBanner} from "./ClosingBanner";

export const Layout: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Header />
            <ClosingBanner />

            <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                {children}
            </div>
        </div>
    );
};
